<template>
  <div class="app-container">
    <NavBar class="fixed-navbar"/>
    <div class="main-content">
      <router-view/>
    </div>
  </div>
</template>

<script setup>
import NavBar from "./component/base/NavBar"
</script>

<style>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.main-content {
  margin-top: 55px; /* Height of navbar */
  flex: 1;
}
</style>

